<template>
    <time :datetime="`PT${value}S`">{{ value|readingTime(language) }}</time>
</template>

<script>
    export default {
        props: {
            value: {
                type: Number,
                required: true,
            },
            language: {
                type: String,
                default: 'en',
            },
        },
    };
</script>
